import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const saveWorkRequirementService = async (workReqService, entityID, serviceID, bundleID, navigate) => {
  const accesstoken = getToken();

  const safeParseFirstAreaID = (areaIDs) => {
    try {
      const parsedAreaIDs = typeof areaIDs === "string" ? JSON.parse(areaIDs) : Array.isArray(areaIDs)
        ? areaIDs : [];
      return parsedAreaIDs;
    } catch {
      console.log('error');
      return [];
    }
  };

  if (accesstoken) {
    try {
      // Parse daysOfWeek from string "[2]" to array [2] if needed
      const parseDaysOfWeek = (value) => {
        if (value === null || value === undefined) return null;
        if (Array.isArray(value)) return value;
        if (typeof value === "string") {
          try {
            return JSON.parse(value);
          } catch {
            return null;
          }
        }
        return null;
      };

      // Parse monthConfiguration from string to array if needed
      const parseMonthConfig = (value) => {
        if (value === null || value === undefined) return null;
        if (Array.isArray(value)) return value;
        if (typeof value === "string") {
          try {
            return JSON.parse(value);
          } catch {
            return null;
          }
        }
        return null;
      };

      let Payload =
      {
        workReqID: workReqService.workReqID,
        entityID: entityID,
        subServiceID: serviceID,
        bundleID: bundleID,
        description: workReqService.description,
        propertyAreaIDs: safeParseFirstAreaID(workReqService.propertyAreaIDs),
        specialInstructions: workReqService.specialInstructions,
        jobs: workReqService.jobs ? workReqService.jobs.map(job => ({
          ...job,
          assignees: transformAssignees(job.assignees)
        })) : [{ jobID: 0, occurrenceNo: 0, status:'Unscheduled' }],
        jobType: workReqService.jobType,
        billingType: workReqService.billingType,
        frequency: workReqService.frequency,
        numberOfOccurrences: workReqService.numberOfOccurrences,
        firstOccurrenceDate: workReqService.firstOccurrenceDate,
        excludeWeekends: workReqService.excludeWeekends,
        excludeHolidays: workReqService.excludeHolidays,
        daysOfWeek: parseDaysOfWeek(workReqService.daysOfWeek),
        weekConfiguration: workReqService.weekConfiguration,
        monthConfiguration: parseMonthConfig(workReqService.monthConfiguration),
        intervalDays: workReqService.intervalDays
      };

      // console.log(Payload);
      const response = await fetch(`${dev_baseUrl}/WorkRequirement/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });

      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else if (response.ok && !data.isError) {
        return data;
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError: true, message: 'An error occurred. Please try again later.', error: error };
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};


// Helper function to handle both formats
function transformAssignees(assignees) {
  if (!assignees) return [];

  // If already in correct format (array of numbers)
  if (Array.isArray(assignees) && assignees.every(item => typeof item === 'number')) {
    return assignees;
  }

  // If in object format (array of {employeeID, employeeName})
  if (Array.isArray(assignees)) {
    return assignees.map(a => a.employeeID).filter(id => id !== undefined);
  }

  return [];
}